import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

class DeadView extends React.Component {

	render() {

        return (
            <div class="main3" id="main">
                <div class="showWhileDead">
                    Invite friends to this game:<br/>
                    { this.props.joinLinkText }
                </div>
            </div>
        );
	}
}

DeadView.propTypes = {
  joinLinkText: PropTypes.string,
};

export default DeadView;